import { dbtModelCountsOf, dbtModelCountsSentence } from "@shared/types/dbtModelCounts";
import type { DbtJobRunRow } from "@shared/types/transformations";
import { formatDuration } from "@/components/runs/runFormatting";

/**
 * Round 6 (T5, W6): the words one transform run's counts and durations are said in, wherever
 * the Transformations screens show them, so the Details pane, History and the strip agree.
 */

/** "0 of 4 built: 2 failed, 2 skipped because a model they depend on failed", or a dash. */
export function modelsBuiltSentence(
  row: Pick<
    DbtJobRunRow,
    "modelsReported" | "modelsFailed" | "modelsSucceeded" | "modelsSkipped" | "modelsNotRun"
  >,
): string {
  const counts = dbtModelCountsOf(row);
  return counts ? dbtModelCountsSentence(counts) : "—";
}

/**
 * W6: "Run 1m 14s · dbt step 1m 04s" when both are known, so the run's duration (what Runs and
 * Overview show) and the dbt step's (what the step row records) are never two unnamed numbers;
 * the dbt step's alone otherwise, as before.
 */
export function runAndStepDuration(
  row: Pick<DbtJobRunRow, "durationSeconds" | "runDurationSeconds">,
): string {
  const run = row.runDurationSeconds;
  if (run === null || run === undefined || row.durationSeconds === null) {
    return formatDuration(row.durationSeconds);
  }
  return `Run ${formatDuration(run)} · dbt step ${formatDuration(row.durationSeconds)}`;
}
